import { render } from "./LoginComponent.vue?vue&type=template&id=e51f6dbc"
import script from "./LoginComponent.vue?vue&type=script&lang=js"
export * from "./LoginComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\vue\\evangelio-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__